export default __webpack_public_path__ + "static/media/Hastening Atlantean Relic.b64429c6.jpg";